module.exports = __webpack_public_path__ + "img/divider-right.848b0702.svg";